import actionTypes from 'dashboard/actions/eft-history/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_EFT_HISTORY_SUCCESS:
      return [...action.items];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/eft-history/items.js